const { InfluxDB, flux, fluxDuration } = require('@influxdata/influxdb-client')
import { Station } from '@/models/station.js'
import { ElectricMeter } from '@/models/electricMeter.js'
import { PowerUnit } from '@/models/powerUnit.js'
import { ServiceUnit } from '@/models/serviceUnit.js'
import { ModemUnit } from '@/models/modemUnit.js'
import { Metric } from '@/models/objectPrototype.js'
import { INFLUX_DB_URL } from "@/app.conf"
import { dateTimeToRFC3339, calculateTimeWindows } from '@/helpers.js'




/*
* Parse timedate string from API as UTC time. Returns Date Object.
*/
export function parseTimeDate(td, toLocal=false) {
	//console.log("parseTimeDate input ", td, "output ", raw)
	//console.log(raw.getFullYear(),raw.getMonth(),raw.getDate(),raw.getHours(),raw.getMinutes(),raw.getSeconds())
	const raw = td instanceof Date ? td : new Date(td)

	if (toLocal) {
		return new Date(Date.UTC(
			raw.getFullYear(),
			raw.getMonth(),
			raw.getDate(),
			raw.getHours(),
			raw.getMinutes(),
			raw.getSeconds()
		))
	} else {
		return raw
	}

	/* Alternative realization
	const raw = new Date(td)
	const rawMs = raw.getTime()
	const rawMsLocal = rawMs - (new Date().getTimezoneOffset() * 60 * 1000)
	return new Date(rawMsLocal)
	*/
}




export const INFLUXDB = {
	url: INFLUX_DB_URL,
	org: 'GazInvest',
	timeout: 10000,
	// Схема БД
	passport: {
		bucket: 'passport',
		start_time: fluxDuration('-3y'),
		station: "station",
	},
	station_metrics: {
		bucket: 'station_metrics',
		start_time: fluxDuration('-1y'),
		power_unit: "power_unit",
		service_unit: "service_unit",
		electric_meter_unit: "electric_meter_unit",
		modem_unit: 'modem_unit',
		alerts: 'alert',
		breaker: 'breaker',
	},
	post_metrics: {
		bucket: 'post_metrics',
		start_time: fluxDuration('-1y'),
		measurements:{
			E: "E",
			Vbat: "v_bat",
			VbackupBat: "v_backup_bat",
		}
	},
	log: {
		bucket: 'log',
		start_time: fluxDuration('-15m'),
		measurement: 'app_log',
	},
}


// DB objects
let client = undefined
export let queryApi = undefined


// Need init API before use
export function initInfluxApi(apiToken) {
	client = new InfluxDB({ url: INFLUXDB.url, token: apiToken })
	queryApi = client.getQueryApi(INFLUXDB.org)
}


export async function updateStationMetrics(stations, timeoutMs = INFLUXDB.timeout) {
	// Updates metrics for stations in Map[id: Station, ...]
	let queryComlete = false
	let remappedStations = new Map()

	const exclude_keys = ["_field", "_measurement", "_start",
		"_stop", "_time", "_value", "table", "result", "station_id"]

	let stationsIdArr = []
	stations.forEach((station) => {
		stationsIdArr.push(station.passport.get("metrics_id"))
		remappedStations.set(station.passport.get("metrics_id"), station)
	})

	let query = flux`
		// Список id станцій
		org_ids_arr = ${stationsIdArr}

		// Запит метрик станцій
		from(bucket: ${INFLUXDB.station_metrics.bucket})
		|> range(start: ${INFLUXDB.station_metrics.start_time})
		|> filter(fn: (r) => r["_measurement"] == ${INFLUXDB.station_metrics.power_unit}
			or r["_measurement"] == ${INFLUXDB.station_metrics.service_unit}
			or r["_measurement"] == ${INFLUXDB.station_metrics.electric_meter_unit}
			or r["_measurement"] == ${INFLUXDB.station_metrics.modem_unit}
			or r["_measurement"] == ${INFLUXDB.station_metrics.breaker})
		|> last()
		|> filter(fn: (r) => contains(value: r["station_id"], set: org_ids_arr))
		|> sort(columns: ["station_id"])
		//|> pivot(rowKey:["station_id"], columnKey: ["_field"], valueColumn: "_value")
	`

	//console.log("Query", query.fluxValue)

	let observer = {
		// Iterate rows (station passports)
		next(row, tableMeta) {
			const metrics = tableMeta.toObject(row);
			const station_id = String(metrics.station_id)
			let unit = undefined

			// if (station_id == "1")
			//   console.log(metrics)

			// Exit, if no station
			const station = remappedStations.get(station_id)
			if (station == undefined)
				return

			if (metrics["_measurement"] == INFLUXDB.station_metrics.power_unit) {
				unit = station.power_unit.metrics
			} else if (metrics["_measurement"] == INFLUXDB.station_metrics.service_unit) {
				unit = station.service_unit.metrics
			} else if (metrics["_measurement"] == INFLUXDB.station_metrics.electric_meter_unit) {
				unit = station.electricMeter.metrics
			} else if (metrics["_measurement"] == INFLUXDB.station_metrics.modem_unit) {
				unit = station.modem_unit.metrics
			} else if (metrics["_measurement"] == INFLUXDB.station_metrics.breaker) {
				unit = station.breaker.metrics
			} else {
				return
			}

			const meta = Object.keys(metrics)
				.filter(key => !exclude_keys.includes(key))
				.reduce((obj, key) => {
					obj[key] = metrics[key];
					return obj;
				}, {});

			// Update metrics only if read newer value
			// (|> last() in query don`t working for metrics with different tags)
			if (unit.has(metrics["_field"]) &&
				unit.get(metrics["_field"]).time > new Date(metrics["_time"])) {
				return
			}

			unit.set(
				metrics["_field"],
				new Metric(
					metrics["_field"],
					metrics["_value"],
					new Date(metrics["_time"]),
					unit.has(metrics["_field"]) ? Object.assign(unit.get(metrics["_field"]).meta, meta) : meta
				)
			)
		},
		error(error) {
			console.error("Error on read metrics: " + error)
		},
		complete() {
			stations.forEach((station) => {
				station.fetch_time = new Date()
			})

			queryComlete = true
		},
	}
	observer.next = observer.next.bind(this)
	observer.complete = observer.complete.bind(this)

	//queryApi.queryRows(query, observer)
	try {
		// Begin query
		queryApi.queryRows(query, observer)

		// Wait for request comlete
		return await new Promise((resolve) => {
			const timeWas = new Date();
			const wait = setInterval(function() {
			if (queryComlete) {
				//console.log("QueryStations complete after", new Date() - timeWas, "ms");
				clearInterval(wait);

				resolve(true);
			} else if (new Date() - timeWas > timeoutMs) { // Timeout
				console.error("Update metrics timeout after", new Date() - timeWas, "ms");
				clearInterval(wait);
				resolve(false);
			}
			}, 20);
		})
	} catch {
		throw `Update metrics error.`
	}
}


export async function updateStationMetricsStartValues(station, timeoutMs = INFLUXDB.timeout) {
	// Updates metrics for stations in Map[id: Station, ...]
	let queryComlete = false

	const from = station.passport?.get(Station.passportKeys.powerUnit.self)[Station.passportKeys.powerUnit.operaionAndProtectionStartDate] ?
		dateTimeToRFC3339(new Date(station.passport?.get(Station.passportKeys.powerUnit.self)[Station.passportKeys.powerUnit.operaionAndProtectionStartDate])) :
		fluxDuration('-1s')
	
	let query = flux`
		// Запит метрик станції
		from(bucket: ${INFLUXDB.station_metrics.bucket})
		|> range(start: ` + from + flux`)
		|> filter(fn: (r) => r["_measurement"] == ${INFLUXDB.station_metrics.power_unit})
		|> filter(fn: (r) => r["_field"] == ${PowerUnit.metricKeys.operationTime} or
			r["_field"] == ${PowerUnit.metricKeys.protectionTime})
		|> filter(fn: (r) => r["station_id"] == "${station.passport?.get(Station.passportKeys.metricsId)}")
		|> first()
	`
	//console.log("Query", query.fluxValue)

	let observer = {
		// Iterate rows (station passports)
		next(row, tableMeta) {
			const metric = tableMeta.toObject(row);

			//console.log("Metric " + metric._field, metric)
			if (station.power_unit.metrics.has(metric["_field"])) {
				const stationMetric = station.power_unit.metrics.get(metric["_field"]);
				
				if (stationMetric !== undefined) {
					stationMetric.meta["start_value"] = metric["_value"];
				}

				//console.log("Station metric " + metric._field, stationMetric);
			}
		},
		error(error) {
			console.error("Error on read metrics: " + error)
		},
		complete() {
			queryComlete = true
		},
	}
	observer.next = observer.next.bind(this)
	observer.complete = observer.complete.bind(this)

	//queryApi.queryRows(query, observer)
	try {
		// Begin query
		queryApi.queryRows(query, observer)

		// Wait for request comlete
		return await new Promise((resolve) => {
			const timeWas = new Date();
			const wait = setInterval(function() {
			if (queryComlete) {
				//console.log("QueryStations complete after", new Date() - timeWas, "ms");
				clearInterval(wait);
				resolve(true);
			} else if (new Date() - timeWas > timeoutMs) { // Timeout
				console.error("Update metrics timeout after", new Date() - timeWas, "ms");
				clearInterval(wait);
				resolve(false);
			}
			}, 20);
		})
	} catch {
		throw `Update metrics error.`
	}
}


export async function updatePostMetrics(posts, timeoutMs = INFLUXDB.timeout) {
	// Updates metrics for posts in Map[id: Post, ...]
	let queryComlete = false
	let remappedPosts = new Map()

	const exclude_keys = ["_start",
		"_stop", "_time", "_value", "_field", "_measurement", "table", "result", "post_id"]

	let postsIdArr = []
	posts.forEach((post) => {
		postsIdArr.push(post.passport.get("metrics_id"))
		remappedPosts.set(post.passport.get("metrics_id"), post)
	})

	let query = flux`
		// Список id станцій
		org_ids_arr = ${postsIdArr}

		// Запит метрик станцій
		from(bucket: ${INFLUXDB.post_metrics.bucket})
		|> range(start: ${INFLUXDB.post_metrics.start_time})
		|> last()
		|> filter(fn: (r) => contains(value: r["post_id"], set: org_ids_arr))
		|> sort(columns: ["post_id"])
		//|> pivot(rowKey:["post_id"], columnKey: ["_field"], valueColumn: "_value")
	`

	//console.log("Query", query.fluxValue)

	let observer = {
		// Iterate rows (post passports)
		next(row, tableMeta) {
			const metrics = tableMeta.toObject(row);
			const post_id = String(metrics.post_id)
			
			// if (post_id == "1")
			//   console.log(metrics)

			// Exit, if no post
			const post = remappedPosts.get(post_id)
			if (post == undefined)
				return

			const meta = Object.keys(metrics)
				.filter(key => !exclude_keys.includes(key))
				.reduce((obj, key) => {
					obj[key] = metrics[key];
					return obj;
				}, {});

			const metricName = `${metrics["_measurement"]}_${metrics["_field"]}`

			// Update metrics only if read newer value
			// (|> last() in query don`t working for metrics with different tags)
			if (post.metrics.has(metricName) &&
				post.metrics.get(metricName).time > new Date(metrics["_time"])) {
				return
			}

			post.metrics.set(
				metricName,
				new Metric(
					metricName,
					metrics["_value"],
					new Date(metrics["_time"]),
					meta
				)
			)
		},
		error(error) {
			console.error("Error on read post metrics: " + error)
		},
		complete() {
			posts.forEach((post) => {
				post.fetch_time = new Date()
			})

			queryComlete = true
		},
	}
	observer.next = observer.next.bind(this)
	observer.complete = observer.complete.bind(this)

	//queryApi.queryRows(query, observer)
	try {
		// Begin query
		queryApi.queryRows(query, observer)

		// Wait for request comlete
		return await new Promise((resolve) => {
			const timeWas = new Date();
			const wait = setInterval(function() {
			if (queryComlete) {
				//console.log("QueryPosts complete after", new Date() - timeWas, "ms");
				clearInterval(wait);
				resolve(true);
			} else if (new Date() - timeWas > timeoutMs) { // Timeout
				console.error("Update metrics timeout after", new Date() - timeWas, "ms");
				clearInterval(wait);
				resolve(false);
			}
			}, 20);
		})
	} catch {
		throw `Update metrics error.`
	}
}


export async function updateUnitsLastConnectTime(stations, timeoutMs = INFLUXDB.timeout) {
	// Updates metrics for stations in Map[id: Station, ...]
	let queryComlete = false
	let remappedStations = new Map()

	let stationsIdArr = []
	stations.forEach((station) => {
		stationsIdArr.push(station.passport.get("metrics_id"))
		remappedStations.set(station.passport.get("metrics_id"), station)
	})

	let query = flux`
		// Список id станцій
		org_ids_arr = ${stationsIdArr}

		from(bucket: ${INFLUXDB.station_metrics.bucket})
			|> range(start: ${INFLUXDB.station_metrics.start_time})
			|> filter(fn: (r) => r["_measurement"] == ${INFLUXDB.station_metrics.power_unit}
				or r["_measurement"] == ${INFLUXDB.station_metrics.service_unit}
				or r["_measurement"] == ${INFLUXDB.station_metrics.electric_meter_unit}
				or r["_measurement"] == ${INFLUXDB.station_metrics.modem_unit}
				)
			|> filter(fn: (r) => r["_field"] == "is_connection")
			|> filter(fn: (r) => r["_value"] == true)
			|> last()
			|> filter(fn: (r) => contains(value: r["station_id"], set: org_ids_arr))
	`

	//console.log("Query", query.fluxValue)

	let observer = {
		// Iterate rows (station passports)
		next(row, tableMeta) {
			const metrics = tableMeta.toObject(row);
			const station_id = String(metrics.station_id)
			let unit = undefined
			let key

			// Exit, if no station
			const station = remappedStations.get(station_id)
			if (station == undefined)
				return

			if (metrics["_measurement"] == INFLUXDB.station_metrics.power_unit) {
				unit = station.power_unit.metrics
				key = PowerUnit.metricKeys.lastConnection
			} else if (metrics["_measurement"] == INFLUXDB.station_metrics.service_unit) {
				unit = station.service_unit.metrics
				key = ServiceUnit.metricKeys.lastConnection
			} else if (metrics["_measurement"] == INFLUXDB.station_metrics.electric_meter_unit) {
				unit = station.electricMeter.metrics
				key = ElectricMeter.metricKeys.lastConnection
			} else if (metrics["_measurement"] == INFLUXDB.station_metrics.modem_unit) {
				unit = station.modem_unit.metrics
				key = ElectricMeter.metricKeys.lastConnection
			} else
				return

			unit.set(
				key,
				new Metric(
					key,
					new Date(metrics["_time"]),
					new Date(metrics["_time"])
				)
			)
		},
		error(error) {
			console.error("Error on read last connection time: " + error)
		},
		complete() {
			queryComlete = true
		},
	}
	observer.next = observer.next.bind(this)
	observer.complete = observer.complete.bind(this)

	//queryApi.queryRows(query, observer)
	try {
		// Begin query
		queryApi.queryRows(query, observer)

		// Wait for request comlete
		return await new Promise((resolve) => {
			const timeWas = new Date();
			const wait = setInterval(function() {
			if (queryComlete) {
				//console.log("QueryStations complete after", new Date() - timeWas, "ms");
				clearInterval(wait);
				resolve(true);
			} else if (new Date() - timeWas > timeoutMs) { // Timeout
				console.error("Update metrics timeout after", new Date() - timeWas, "ms");
				clearInterval(wait);
				resolve(false);
			}
			}, 20);
		})
	} catch {
		throw `Read last connection time error.`
	}
}


/* Update specific metric last value and time for stations
* stations: Station objects array
* specificMetricKey: metric key
* unit: unit key for query
* metric: metric key for query
* value: metric value if need to update specific value time
* search depth in past time (time string in influx format)
* response wait timeout
*/
export async function updateMetricLastTime(stations, specificMetricKey, unit, metric, value=null, depth='1y', timeoutMs = INFLUXDB.timeout) {
	let queryComlete = false
	let remappedStations = new Map()

	stations.forEach((station) => {
		remappedStations.set(station.passport.get("metrics_id"), station)
	})

	let query = flux`
		// Station ids list
		station_ids_arr = ${new Array(...remappedStations.keys())}
		from(bucket: ${INFLUXDB.station_metrics.bucket})
			|> range(start: -` + depth + flux`)
			|> filter(fn: (r) => r["_measurement"] == ${unit})
			|> filter(fn: (r) => r["_field"] == ${metric})
	`
	if (value !== null) {
		query += `
			|> filter(fn: (r) => r["_value"] == ${value})
		`
	}
		
	query += flux`
			|> last()
			|> filter(fn: (r) => contains(value: r["station_id"], set: station_ids_arr))
	`

	let observer = {
		// Iterate rows (station passports)
		next(row, tableMeta) {
			const metrics = tableMeta.toObject(row);
			const station_id = String(metrics.station_id)

			// Exit, if no station
			const station = remappedStations.get(station_id)
			if (station == undefined)
				return

			station.specificMetrics[specificMetricKey] = parseTimeDate(metrics["_time"])
		},
		error(error) {
			console.error(`Error on read ${metric} last time: ` + error)
		},
		complete() {
			queryComlete = true
		},
	}
	observer.next = observer.next.bind(this)
	observer.complete = observer.complete.bind(this)

	//queryApi.queryRows(query, observer)
	try {
		// Begin query
		queryApi.queryRows(query, observer)

		// Wait for request comlete
		return await new Promise((resolve) => {
			const timeWas = new Date();
			const wait = setInterval(function() {
			if (queryComlete) {
				//console.log("QueryStations complete after", new Date() - timeWas, "ms");
				clearInterval(wait);
				resolve(true);
			} else if (new Date() - timeWas > timeoutMs) { // Timeout
				console.error("Update metrics timeout after", new Date() - timeWas, "ms");
				clearInterval(wait);
				resolve(false);
			}
			}, 20);
		})
	} catch {
		throw `Read last connection time error.`
	}
}


/* Read one metric from one station
* stationId: station Id
* unit: unit name
* metricName: name of metric
* metrics: Array of Objects where metric values will bee pushed { time: *, value: * }
* timeFrom, timeTo: time period for metric
* timeoutMs: response wait timeout
*/
export async function readStationMetric(
	stationId,
	unit,
	metricName,
	metrics,
	timeFrom,
	timeTo='now',
	timeoutMs=INFLUXDB.timeout,
	signal=undefined
) {
	let queryComlete = false
	const tableRowsMap = new Map()

	const from = Object.prototype.toString.call(timeFrom) === '[object Date]' ?
		dateTimeToRFC3339(timeFrom) :
		fluxDuration('-1s')

	const to = Object.prototype.toString.call(timeTo) === '[object Date]' ?
		dateTimeToRFC3339(timeTo) :
		fluxDuration('-1s')
	
	let query = ''

	// If read one metric
	if (Object.prototype.toString.call(metricName) == '[object String]') {
		query = flux`
			from(bucket: ${INFLUXDB.station_metrics.bucket})
				|> range(start: ` + from + flux`, stop: ` + to + flux`)
				|> filter(fn: (r) => r["_measurement"] == ${unit})
				|> filter(fn: (r) => r["_field"] == ${metricName})
				|> filter(fn: (r) => r["station_id"] == "${stationId}")
		`
	} else {
		throw `Read station metric error: unknown metric`
	}
	// console.log("Query", query.fluxValue)
	
	let observer = {
		// Iterate rows
		next(row, tableMeta) {
			const rawRecord = tableMeta.toObject(row);
			// console.log("Record: ", rawRecord)
			const record = {}

			record[rawRecord._field] = rawRecord._value
			record['time'] = parseTimeDate(rawRecord._time)

			if (tableRowsMap.has(rawRecord._time)) {
				Object.assign(tableRowsMap.get(rawRecord._time), record)
			} else {
				tableRowsMap.set(rawRecord._time, record)
			}
		},
		error(error) {
			console.error(`Error on read station metric "${metricName}": ` + error)
		},
		complete() {
			queryComlete = true
		},
	}
	observer.next = observer.next.bind(this)
	observer.complete = observer.complete.bind(this)

	try {
		// Begin query
		queryApi.queryRows(query, observer)

		// Wait for request comlete
		const ret = await new Promise((resolve) => {
			const timeWas = new Date();
			const wait = setInterval(function() {
					if (queryComlete) {
						clearInterval(wait)
						resolve(true)
					} else if (new Date() - timeWas > timeoutMs) { // Timeout
						console.error("Update metric timeout after", new Date() - timeWas, "ms")
						clearInterval(wait)
						resolve(false)
					} else if (signal?.aborted) {
						console.log('Aborted')
						clearInterval(wait)
						resolve(false)
					}
				},
				20
			)
		})

		tableRowsMap.forEach((value) => metrics.push(value))

		return ret
	} catch {
		throw `Read station metric error.`
	}
}


/* Read array of metrics from one station
* stationId: station Id
* metricNames: array of metric names
* unit: Array of unit names from wich station unit read the metric
*	[INFLUXDB.station_metrics.power_unit, INFLUXDB.station_metrics.service_unit]
* metrics: Array of Objects where metric values will bee pushed
*	{ time: *, [unit_metric_median]: *, [unit_metric_min]: *, [unit_metric_max]: * }
* timeFrom, timeTo: time period for metric
* windowPeriod:
* metricfunctions: function that apply to every metric.
* timeoutMs: response wait timeout
*/
export async function readStationMetrics(
	stationId,
	units,
	metricNames,
	metrics,
	timeFrom,
	timeTo='now',
	windowPeriod=undefined,
	metricfunctions=['min', 'max', 'median',], // variants: 'min', 'max', 'median', 'unique'
	timeoutMs=INFLUXDB.timeout,
	signal=undefined,
) {
	let queryComlete = false

	const tableRowsMap = new Map()

	const from = Object.prototype.toString.call(timeFrom) === '[object Date]' ?
		dateTimeToRFC3339(timeFrom) :
		fluxDuration('-1s')

	const to = Object.prototype.toString.call(timeTo) === '[object Date]' ?
		dateTimeToRFC3339(timeTo) :
		fluxDuration('-1s')
	
	let query = ''

	let period = windowPeriod ? windowPeriod : '10m'
	if (Object.prototype.toString.call(timeFrom) === '[object Date]'
		&& Object.prototype.toString.call(timeTo) === '[object Date]'
		&& windowPeriod === undefined
	) {
		period = calculateTimeWindows(timeFrom, timeTo).influxDbPeriod
	}

	if (Object.prototype.toString.call(metricNames) != '[object Array]') {
		throw `Read station metrics error: metricNames is not array`
	}

	query = flux`
	common = from(bucket: ${INFLUXDB.station_metrics.bucket})
		|> range(start: ` + from + flux`, stop: ` + to + flux`)
		|> filter(fn: (r) => r["_measurement"] == ${units[0]}`
		for (var i = 1; i < units.length; i++) {
			query += flux` or r["_measurement"] == "${units[i]}"`
		}
	query += flux`)`
	query += flux`
		|> filter(fn: (r) => r["_field"] == "${metricNames[0]}"`
		for (var j = 1; j < metricNames.length; j++) {
			query += flux` or r["_field"] == "${metricNames[j]}"`
		}
	query += flux`)`
	query += flux`
		|> filter(fn: (r) => r["station_id"] == "${stationId}")`
	
	let unionArr = []
	if (metricfunctions.includes('median')) {
		query += flux`
			medianMetrics = common
				|> aggregateWindow(every: `+ period + flux`, fn: median, createEmpty: false)
				|> set(key: "line", value: "median")
		`
		unionArr.push('medianMetrics')
	}

	if (metricfunctions.includes('min')) {
		query += flux`
			minMetrics = common
				|> aggregateWindow(every: `+ period + flux`, fn: min, createEmpty: false)
				|> set(key: "line", value: "min")
		`
		unionArr.push('minMetrics')
	}

	if (metricfunctions.includes('max')) {
		query += flux`
			maxMetrics = common
				|> aggregateWindow(every: `+ period + flux`, fn: max, createEmpty: false)
				|> set(key: "line", value: "max")
		`
		unionArr.push('maxMetrics')
	}

	if (metricfunctions.includes('unique')) {
		query += flux`
			uniqueMetrics = common
				//|> unique()
				//|> aggregateWindow(every: 10h, fn: unique, createEmpty: false)
				|> toInt()
				|> duplicate(column: "_value", as: "prev_diff")            // клон для difference
				|> sort(columns: ["_time"], desc: false)                   // упорядкувати по часі
				|> difference(columns: ["prev_diff"])                      // різниця з попереднім
				|> filter(fn: (r) => r.prev_diff != 0.0)                   // залишити лише зміни
				|> drop(columns: ["prev_diff"])                            // прибрати технічну колонку
				|> set(key: "line", value: "unique")
		`
		unionArr.push('uniqueMetrics')
	}

	if (unionArr.length > 1) {
		query += flux`union(tables:[` + unionArr.join() + '])'
	} else {
		query += flux`|> yield(name: "single")`
	}
	
	let observer = {
		// Iterate rows
		next(row, tableMeta) {
			const rawRecord = tableMeta.toObject(row);
			// console.log("Record: ", rawRecord)
			const record = {}
			
			record[rawRecord._measurement + '_' + rawRecord._field + '_' + rawRecord.line] = rawRecord._value
			record['time'] = parseTimeDate(rawRecord._time)

			if (tableRowsMap.has(rawRecord._time)) {
				Object.assign(tableRowsMap.get(rawRecord._time), record)
			} else {
				tableRowsMap.set(rawRecord._time, record)
			}
		},
		error(error) {
			console.error('Error on read station metrics: ' + error)
		},
		complete() {
			queryComlete = true
		},
	}
	observer.next = observer.next.bind(this)
	observer.complete = observer.complete.bind(this)

	try {
		// Begin query
		queryApi.queryRows(query, observer)

		// Wait for request comlete
		const ret = await new Promise((resolve) => {
			const timeWas = new Date();
			const wait = setInterval(
				function() {
					if (queryComlete) {
						clearInterval(wait)
						resolve(true)
					} else if (new Date() - timeWas > timeoutMs) { // Timeout
						console.error("Update metrics timeout after", new Date() - timeWas, "ms")
						clearInterval(wait)
						resolve(false)
					} else if (signal?.aborted) {
						console.log('Aborted')
						clearInterval(wait)
						resolve(false)
					}
				},
				20
			)
		})

		tableRowsMap.forEach((value) => metrics.push(value))

		return ret
	} catch {
		throw `Read station metrics error.`
	}
}


export const LOG_LEVELS = Object.freeze({
	'10': 'debug',
	'20': 'info',
	'25': 'success',
	'30': 'warning',
	'40': 'error',
	'50': 'critical',
})

/*
* Universal log reader for staion and post
*/
export async function readObjectLog(objectId, recordsArr, timeFrom=null, timeTo=null, timeoutMs = INFLUXDB.timeout) {
	let queryComlete = false

	const exclude_keys = ["_field", "_measurement", "_start",
		"_stop", "table", "result"]

	const objectIdStation = "S_" + objectId
	const objectIdPost = "P_" + objectId

	const from = Object.prototype.toString.call(timeFrom) === '[object Date]' ?
		dateTimeToRFC3339(timeFrom) :
		INFLUXDB.log.start_time
	const to = Object.prototype.toString.call(timeTo) === '[object Date]' ?
		dateTimeToRFC3339(timeTo) :
		fluxDuration('-1s')

	let query = flux`
		from(bucket: ${INFLUXDB.log.bucket})
			|> range(start: ` + from + flux`, stop: ` + to + flux`)
			|> filter(fn: (r) => r["_measurement"] == ${INFLUXDB.log.measurement})
			|> filter(fn: (r) => r["_field"] == "msg")
			|> filter(fn: (r) => r["src"] == "${objectIdPost}" or r["src"] == "${objectIdStation}")
	`
	//console.log("Query ", query)

	let observer = {
		// Iterate rows
		next(row, tableMeta) {
			const rawRecord = tableMeta.toObject(row);

			const record = Object.keys(rawRecord)
				.filter(key => !exclude_keys.includes(key))
				.reduce((obj, key) => {
					obj[key] = rawRecord[key];
					return obj;
				}, {});

			record._time = parseTimeDate(record._time)
			if (record.level in LOG_LEVELS) {
				record.level = LOG_LEVELS[record.level]
			}

			recordsArr.push(record)

			//console.log("Record", record)
		},
		error(error) {
			console.error("Error on read object log: " + error)
		},
		complete() {
			queryComlete = true
		},
	}
	observer.next = observer.next.bind(this)
	observer.complete = observer.complete.bind(this)

	//queryApi.queryRows(query, observer)
	try {
		// Begin query
		queryApi.queryRows(query, observer)

		// Wait for request comlete
		return await new Promise((resolve) => {
			const timeWas = new Date();
			const wait = setInterval(function() {
			if (queryComlete) {
				clearInterval(wait);
				resolve(true);
			} else if (new Date() - timeWas > timeoutMs) { // Timeout
				console.error("Update metrics timeout after", new Date() - timeWas, "ms");
				clearInterval(wait);
				resolve(false);
			}
			}, 20);
		})
	} catch (error) {
		throw `Read object log error: ${error}`
	}
}


export async function readStationReportTable(
	stationId,
	timeFrom,
	timeTo,
	tableRowsArr,
	windowPeriod='1h',
	timeoutMs = INFLUXDB.timeout
) {
	const tableRowsMap = new Map()
	let queryComlete = false
	
	let powerUnitAlertKeys = []
	PowerUnit.alertKeys.forEach(key => {
		powerUnitAlertKeys.push('"' + key + '"')
	})

	let serviceUnitAlertKeys = []
	ServiceUnit.securityCircuitKeys.forEach(key => {
		serviceUnitAlertKeys.push('"' + key + '"')
	})
	//console.log("alertKeys", alertKeys)
	
	let queryPowerUnit = flux`
	import "internal/debug"

	left = 
	from(bucket: "${INFLUXDB.station_metrics.bucket}")
		|> range(start: ` + dateTimeToRFC3339(timeFrom) + `, stop: ` + dateTimeToRFC3339(timeTo) + `)
		|> filter(fn: (r) => r["_measurement"] == "${INFLUXDB.station_metrics.power_unit}")
		|> filter(fn: (r) => r["_field"] == "Uout" or r["_field"] == "Iout" or r["_field"] == "Uprotect_sum")
		|> filter(fn: (r) => r["station_id"] == "${stationId}")
		|> aggregateWindow(every: ${windowPeriod}, fn: median, createEmpty: true)

	_fields_arr = [
		${powerUnitAlertKeys},
		"${PowerUnit.metricKeys.stationStabilizationMode}",
		"${PowerUnit.metricKeys.stationStabilizationCurent}",
		"${PowerUnit.metricKeys.stationStabilizationVoltage}",
		"${PowerUnit.metricKeys.stationStabilizationPotential}",
		"${PowerUnit.metricKeys.stabilizationModeSetting}",
		"${PowerUnit.metricKeys.stabilizationValueSetting}",
	]
	
	right = 
	from(bucket: "${INFLUXDB.station_metrics.bucket}")
		|> range(start: ` + dateTimeToRFC3339(timeFrom) + `, stop: ` + dateTimeToRFC3339(timeTo) + `)
		|> filter(fn: (r) => r["_measurement"] == "${INFLUXDB.station_metrics.power_unit}")
		|> filter(fn: (r) => contains(value: r["_field"], set: _fields_arr))
		|> filter(fn: (r) => r["station_id"] == "${stationId}")
		|> aggregateWindow(every: ${windowPeriod}, fn: last, createEmpty: true)
	
	_flags_arr = [
		"${PowerUnit.metricKeys.fBreakCurrent}",
		"${PowerUnit.metricKeys.fBreakPotential}",
	]
	flags = 
	from(bucket: "${INFLUXDB.station_metrics.bucket}")
		|> range(start: ` + dateTimeToRFC3339(timeFrom) + `, stop: ` + dateTimeToRFC3339(timeTo) + `)
		|> filter(fn: (r) => r["_measurement"] == "${INFLUXDB.station_metrics.power_unit}")
		|> filter(fn: (r) => r["station_id"] == "${stationId}")
		|> filter(fn: (r) => contains(value: r["_field"], set: _flags_arr))
		|> toInt()
		|> aggregateWindow(every: ${windowPeriod}, fn: mean, createEmpty: true)
	
	union(tables: [left, right, flags])
	`

	let queryServiceUnit = flux`
	left = 
	from(bucket: "${INFLUXDB.station_metrics.bucket}")
		|> range(start: ` + dateTimeToRFC3339(timeFrom) + `, stop: ` + dateTimeToRFC3339(timeTo) + `)
		|> filter(fn: (r) => r["_measurement"] == "${INFLUXDB.station_metrics.service_unit}")
		|> filter(fn: (r) => r["station_id"] == "${stationId}")
		|> filter(fn: (r) => r["_field"] == "U220"
			or r["_field"] == "Uprotect_avg"
			or r["_field"] == "Uprotect_max"
			or r["_field"] == "Uprotect_min"
			or r["_field"] == "off_station_potential_avg"
		)
		|> aggregateWindow(every: ${windowPeriod}, fn: median, createEmpty: true)
	
	_fields_arr = [
		"${ServiceUnit.metricKeys.extPwrCounterEnergy}",
		"${ServiceUnit.metricKeys.tOutdoor}",
		"${ServiceUnit.metricKeys.uAkk}",
	]
	right = 
	from(bucket: "${INFLUXDB.station_metrics.bucket}")
		|> range(start: ` + dateTimeToRFC3339(timeFrom) + `, stop: ` + dateTimeToRFC3339(timeTo) + `)
		|> filter(fn: (r) => r["_measurement"] == "${INFLUXDB.station_metrics.service_unit}")
		|> filter(fn: (r) => r["station_id"] == "${stationId}")
		|> filter(fn: (r) => contains(value: r["_field"], set: _fields_arr))
		|> aggregateWindow(every: ${windowPeriod}, fn: last, createEmpty: true)
	
	_flags_arr = [
		${serviceUnitAlertKeys},
		"${ServiceUnit.metricKeys.fSecurityCircuitBoxDoor}",
		"${ServiceUnit.metricKeys.fExternalPwr}",
	]
	
	flags = 
	from(bucket: "${INFLUXDB.station_metrics.bucket}")
		|> range(start: ` + dateTimeToRFC3339(timeFrom) + `, stop: ` + dateTimeToRFC3339(timeTo) + `)
		|> filter(fn: (r) => r["_measurement"] == "${INFLUXDB.station_metrics.service_unit}")
		|> filter(fn: (r) => r["station_id"] == "${stationId}")
		|> filter(fn: (r) => contains(value: r["_field"], set: _flags_arr))
		|> toInt()
		|> aggregateWindow(every: ${windowPeriod}, fn: mean, createEmpty: false)

	union(tables: [left, right, flags])
	`

	let queryElectricMeterUnit = flux`
	from(bucket: "${INFLUXDB.station_metrics.bucket}")
		|> range(start: ` + dateTimeToRFC3339(timeFrom) + `, stop: ` + dateTimeToRFC3339(timeTo) + `)
		|> filter(fn: (r) => r["_measurement"] == "${INFLUXDB.station_metrics.electric_meter_unit}")
		|> filter(fn: (r) => r["station_id"] == "${stationId}")
		|> filter(fn: (r) => r["_field"] == "${ElectricMeter.metricKeys.fullActiveEnergy}")
		|> aggregateWindow(every: ${windowPeriod}, fn: last, createEmpty: true)
	`

	let queryConnectionUnits = flux`
	from(bucket: "${INFLUXDB.station_metrics.bucket}")
		|> range(start: ` + dateTimeToRFC3339(timeFrom) + `, stop: ` + dateTimeToRFC3339(timeTo) + `)
		|> filter(fn: (r) => r["_measurement"] == "${INFLUXDB.station_metrics.power_unit}"
			or r["_measurement"] == "${INFLUXDB.station_metrics.service_unit}"
			or r["_measurement"] == "${INFLUXDB.station_metrics.modem_unit}")
		|> filter(fn: (r) => r["station_id"] == "${stationId}")
		|> filter(fn: (r) => r["_field"] == "is_connection"
			or r["_field"] == "${ModemUnit.metricKeys.sigLevel_1}"
			or r["_field"] == "${ModemUnit.metricKeys.sigLevel_2}"
		)
		|> aggregateWindow(every: ${windowPeriod}, fn: last, createEmpty: true)
	`
	//console.log("query", query)

	let observer = {
		// Iterate rows
		next(row, tableMeta) {
			const rawRecord = tableMeta.toObject(row)
			// console.log("raw record", rawRecord)
			let record = new Object()

			record["time"] = parseTimeDate(rawRecord._time)
			record[rawRecord._measurement + "_" + rawRecord._field] = rawRecord._value
			// console.log("record", record)
			
			if (tableRowsMap.has(rawRecord._time)) {
				Object.assign(tableRowsMap.get(rawRecord._time), record)
			} else {
				tableRowsMap.set(rawRecord._time, record)
			}
		},
		error(error) {
			console.error("Error on read station report: " + error)
		},
		complete() {
			queryComlete = true
		},
	}
	observer.next = observer.next.bind(this)
	observer.complete = observer.complete.bind(this)

	try {
		let ret1, ret2, ret3, ret4
		// Begin queres
		//
		
		queryComlete = false
		queryApi.queryRows(queryPowerUnit, observer)
		// Wait for request comlete
		ret1 = await new Promise((resolve) => {
			const timeWas = new Date();
			const wait = setInterval(function() {
			if (queryComlete) {
				clearInterval(wait);
				resolve(true);
			} else if (new Date() - timeWas > timeoutMs) { // Timeout
				console.error("Update metrics timeout after", new Date() - timeWas, "ms");
				clearInterval(wait);
				resolve(false);
			}
			}, 20);
		})
		//console.log("ret1", ret1)

		queryComlete = false
		queryApi.queryRows(queryServiceUnit, observer)
		// Wait for request comlete
		ret2 = await new Promise((resolve) => {
			const timeWas = new Date();
			const wait = setInterval(function() {
			if (queryComlete) {
				clearInterval(wait);
				resolve(true);
			} else if (new Date() - timeWas > timeoutMs) { // Timeout
				console.error("Update metrics timeout after", new Date() - timeWas, "ms");
				clearInterval(wait);
				resolve(false);
			}
			}, 20);
		})
		//console.log("ret2", ret2)

		queryComlete = false
		queryApi.queryRows(queryElectricMeterUnit, observer)
		// Wait for request comlete
		ret3 = await new Promise((resolve) => {
			const timeWas = new Date();
			const wait = setInterval(function() {
			if (queryComlete) {
				clearInterval(wait);
				resolve(true);
			} else if (new Date() - timeWas > timeoutMs) { // Timeout
				console.error("Update metrics timeout after", new Date() - timeWas, "ms");
				clearInterval(wait);
				resolve(false);
			}
			}, 20);
		})
		
		queryComlete = false
		queryApi.queryRows(queryConnectionUnits, observer)
		// Wait for request comlete
		ret4 = await new Promise((resolve) => {
			const timeWas = new Date();
			const wait = setInterval(function() {
			if (queryComlete) {			
				clearInterval(wait);
				resolve(true);
			} else if (new Date() - timeWas > timeoutMs) { // Timeout
				console.error("Update connection metrics timeout after", new Date() - timeWas, "ms");
				clearInterval(wait);
				resolve(false);
			}
			}, 20);
		})
		//console.log("ret3", ret3)

		tableRowsMap.forEach((value) => tableRowsArr.push(value))

		return ret1 && ret2 && ret3 && ret4
	} catch {
		throw `Read station report error.`
	}
}


export async function readExternalElecticMeterReportTable(
	stationId,
	timeFrom,
	timeTo,
	tableRowsArr,
	timeoutMs = INFLUXDB.timeout
) {
	// console.log(stationId,
	// 	timeFrom,
	// 	timeTo,
	// 	tableRowsArr,
	// 	timeoutMs)
	const exclude_keys = ["station_id", "_measurement", "_start",
		"_stop", "table", "result"]
	let queryComlete = false

	let query = flux`from(bucket: ${INFLUXDB.station_metrics.bucket})
		|> range(start: ` + dateTimeToRFC3339(timeFrom) + `, stop: ` + dateTimeToRFC3339(timeTo) + `)
		|> filter(fn: (r) => r["_measurement"] == "${INFLUXDB.station_metrics.electric_meter_unit}")
		|> filter(fn: (r) => r["station_id"] == "${stationId}")
		|> filter(fn: (r) => r["_field"] == "${`${ElectricMeter.metricKeys.activeEnergyFullApPam}_1`}"
			or r["_field"] == "${`${ElectricMeter.metricKeys.activeEnergyFullApPam}_2`}"
			or r["_field"] == "${`${ElectricMeter.metricKeys.activeEnergyFullApPam}_3`}"
			or r["_field"] == "${`${ElectricMeter.metricKeys.activeEnergyFullApPam}_4`}"
			or r["_field"] == "${ElectricMeter.metricKeys.fullActiveEnergy}")
		|> aggregateWindow(every: 1mo, fn: last, createEmpty: true)
		|> pivot(rowKey:["_time"], columnKey: ["_field"], valueColumn: "_value")
	`

	let observer = {
		// Iterate rows
		next(row, tableMeta) {
			const rawRecord = tableMeta.toObject(row);
			const record = Object.keys(rawRecord)
				.filter(key => !exclude_keys.includes(key))
				.reduce((obj, key) => {
					obj[key] = rawRecord[key];
					return obj;
				}, {});
			//console.log("Record", record)

			record.time = parseTimeDate(record._time)

			tableRowsArr.push(record)
		},
		error(error) {
			console.error("Error on read electric meter report: " + error)
		},
		complete() {
			queryComlete = true
		},
	}
	observer.next = observer.next.bind(this)
	observer.complete = observer.complete.bind(this)

	//queryApi.queryRows(query, observer)
	try {
		// Begin query
		queryApi.queryRows(query, observer)

		// Wait for request comlete
		return await new Promise((resolve) => {
			const timeWas = new Date();
			const wait = setInterval(function() {
			if (queryComlete) {
				//console.log("QueryStations complete after", new Date() - timeWas, "ms");
				clearInterval(wait);
				resolve(true);
			} else if (new Date() - timeWas > timeoutMs) { // Timeout
				console.error("Read electric meter report timeout after", new Date() - timeWas, "ms");
				clearInterval(wait);
				resolve(false);
			}
			}, 20);
		})
	} catch {
		throw `Read electric meter report error.`
	}
}


export async function readServiceUnitElecticMeterReportTable(
	stationId,
	timeFrom,
	timeTo,
	tableRowsArr,
	timeoutMs = INFLUXDB.timeout
) {
	// console.log(stationId,
	// 	timeFrom,
	// 	timeTo,
	// 	tableRowsArr,
	// 	timeoutMs)
	const exclude_keys = ["station_id", "_measurement", "_start",
		"_stop", "table", "result"]
	let queryComlete = false

	let query = flux`from(bucket: "${INFLUXDB.station_metrics.bucket}")
		|> range(start: ` + dateTimeToRFC3339(timeFrom) + `, stop: ` + dateTimeToRFC3339(timeTo) + `)
		|> filter(fn: (r) => r["_measurement"] == "${INFLUXDB.station_metrics.service_unit}")
		|> filter(fn: (r) => r["station_id"] == "${stationId}")
		|> filter(fn: (r) => r["_field"] == "${ServiceUnit.metricKeys.extPwrCounterEnergy}")
		|> aggregateWindow(every: 1mo, fn: last, createEmpty: true)
	`
	//console.log("Query", query)

	let observer = {
		// Iterate rows
		next(row, tableMeta) {
			const rawRecord = tableMeta.toObject(row);
			const record = Object.keys(rawRecord)
				.filter(key => !exclude_keys.includes(key))
				.reduce((obj, key) => {
					obj[key] = rawRecord[key];
					return obj;
				}, {});
			//console.log("Record", record)

			record.time = parseTimeDate(record._time)
			record[record._field] = record._value
			delete record._field
			delete record._value

			tableRowsArr.push(record)
		},
		error(error) {
			console.error("Error on read electric meter report: " + error)
		},
		complete() {
			queryComlete = true
		},
	}
	observer.next = observer.next.bind(this)
	observer.complete = observer.complete.bind(this)

	//queryApi.queryRows(query, observer)
	try {
		// Begin query
		queryApi.queryRows(query, observer)

		// Wait for request comlete
		return await new Promise((resolve) => {
			const timeWas = new Date();
			const wait = setInterval(function() {
			if (queryComlete) {
				//console.log("QueryStations complete after", new Date() - timeWas, "ms");
				clearInterval(wait);
				resolve(true);
			} else if (new Date() - timeWas > timeoutMs) { // Timeout
				console.error("Read electric meter report timeout after", new Date() - timeWas, "ms");
				clearInterval(wait);
				resolve(false);
			}
			}, 20);
		})
	} catch {
		throw `Read electric meter report error.`
	}
}


export async function readPostReportTable(
	postId,
	timeFrom,
	timeTo,
	tableRowsArr,
	timeoutMs = INFLUXDB.timeout
) {
	const tableRowsMap = new Map()
	let queryComlete = false

	// const exclude_keys = [/*"_field",*/ "_measurement", "_start",
	// 	"_stop", "table", "result"]
		
	let query = flux`
	from(bucket: ${INFLUXDB.post_metrics.bucket})
	|> range(start: ` + dateTimeToRFC3339(timeFrom) + `, stop: ` + dateTimeToRFC3339(timeTo) + `)
		|> filter(fn: (r) => r["_measurement"] == "${INFLUXDB.post_metrics.measurements.E}" or
		r["_measurement"] == "${INFLUXDB.post_metrics.measurements.Vbat}" or
		r["_measurement"] == "${INFLUXDB.post_metrics.measurements.VbackupBat}")
		|> filter(fn: (r) => r["post_id"] == "${postId}")
		//|> aggregateWindow(every: 1d, fn: first, createEmpty: true)
	`
	//console.log("query", query)

	let observer = {
		// Iterate rows
		next(row, tableMeta) {
			const rawRecord = tableMeta.toObject(row)

			// Drop damage records
			if (rawRecord.post_id == undefined) {
				return
			}

			const metricName = `${rawRecord["_measurement"]}_${rawRecord["_field"]}`
			//record[record._field] = record._value
			let record = new Object()
			record.time = parseTimeDate(rawRecord._time)
			record[metricName] =  rawRecord._value

			//console.log("post_id", rawRecord.post_id, "raw record time = ", rawRecord._time, "record time = ", record.time, "record value = ", rawRecord._value)
			
			if (tableRowsMap.has(rawRecord._time)) {
				Object.assign(tableRowsMap.get(rawRecord._time), record)
			} else {
				tableRowsMap.set(rawRecord._time, record)
			}
		},
		error(error) {
			console.error("Error on read post report: " + error)
		},
		complete() {
			queryComlete = true
		},
	}
	observer.next = observer.next.bind(this)
	observer.complete = observer.complete.bind(this)

	try {
		// Begin query
		//
		queryComlete = false
		queryApi.queryRows(query, observer)
		// Wait for request comlete
		let ret = await new Promise((resolve) => {
			const timeWas = new Date();
			const wait = setInterval(function() {
			if (queryComlete) {
				clearInterval(wait);
				resolve(true);
			} else if (new Date() - timeWas > timeoutMs) { // Timeout
				console.error("Read post metrics timeout after", new Date() - timeWas, "ms");
				clearInterval(wait);
				resolve(false);
			}
			}, 20);
		})

		tableRowsMap.forEach((value) => tableRowsArr.push(value))

		return ret
		
	} catch {
		throw `Read post report error.`
	}
}